import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {MasterService} from '../../core/service/master.service';
import {CommonService} from '../../core/service/common.service';
import {MatDialog} from '@angular/material/dialog';
import {SessionService} from '../../core/service/session.service';
import {EventService} from '../../core/service/event.service';
import {EVENT_SHUBETSU_LIST} from '../../shared/constants';

@Component({
  selector: 'app-event-ichiran',
  templateUrl: './event-ichiran.component.html',
  styleUrls: ['../event-calendar/event-calendar.component.scss', './event-ichiran.component.scss']
})
export class EventIchiranComponent implements OnInit {
  constructor(public masterService: MasterService,
              public commonService: CommonService,
              public dialog: MatDialog,
              public eventService: EventService) { }

  /**
   *
   */
  ngOnInit(): void {
  }
}
